import { observer } from 'mobx-react-lite'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import type { ConnectWithProDialogViewModel } from './ConnectWithProDialogViewModel'

export { ConnectWithProDialogViewModel } from './ConnectWithProDialogViewModel'

interface ConnectWithProDialogProps {
  vm: ConnectWithProDialogViewModel
  testId?: string
}

export const ConnectWithProDialog = observer(function ConnectWithProDialog({
  vm,
  testId,
}: ConnectWithProDialogProps) {
  const isConfirming = vm.confirm.pending

  return (
    <ModalDialog
      isOpen={vm.modal.showing}
      onClose={vm.closeDialog}
      isDismissable={!isConfirming}
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>
          Don't notify your Pro until everything is complete
        </ModalDialogTitle>
        <ModalDialogDescription>
          Your Pro will start your return with this information. Missing details
          can slow the process.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter sticky bordered compact>
        <ModalDialogActions>
          <Button
            label="Connect with a Pro"
            variant="default"
            onPress={vm.confirm}
            isPending={isConfirming}
            testId={testId ? `${testId}-connect-button` : undefined}
          />
          <Button
            label="Cancel"
            variant="outline"
            onPress={vm.closeDialog}
            isDisabled={isConfirming}
            testId={testId ? `${testId}-cancel-button` : undefined}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
})
